// RoleBasedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';

const RoleBasedRoute = ({ children, allowedRoles }) => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          setLoading(false);
          return;
        }
        
        setUser(session.user);
        
        // Get user role from profile
        const { data: profile } = await supabase
          .from('user_profiles')
          .select('role')
          .eq('id', session.user.id)
          .single();
        
        setUserRole(profile?.role || 'Employee');
      } catch (error) {
        console.error('Error checking role:', error);
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        paddingTop: '80px'
      }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    // Redirect to appropriate dashboard based on role
    const roleRoutes = {
      'Founder & Chairman': '/dashboard/founder',
      'MD': '/dashboard/md',
      'CEO': '/dashboard/ceo',
      'COO': '/dashboard/coo',
      'CFO': '/dashboard/cfo',
      'Employee': '/dashboard/employee'
    };
    return <Navigate to={roleRoutes[userRole] || '/'} replace />;
  }

  return children;
};

export default RoleBasedRoute;